import apiClient from './apiClient';

const auditService = {
  // Get audit logs with pagination and filters
  getAuditLogs: async (params = {}) => {
    const response = await apiClient.get('/audit/logs', { params });
    return response.data;
  },

  // Get audit summary/statistics
  getAuditSummary: async (params = {}) => {
    const response = await apiClient.get('/audit/summary', { params });
    return response.data;
  },

  // Get user's own activity logs
  getMyActivity: async (params = {}) => {
    const response = await apiClient.get('/audit/my-activity', { params });
    return response.data;
  }
};

export default auditService;